<template>
  <div id="app" :class="{showTabbar: $route.meta.showTabbar}">
    <transition :name="transitionName">
      <keep-alive>
        <router-view class="app-sub-page" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition :name="transitionName">
      <router-view class="app-sub-page" v-if="!$route.meta.keepAlive"></router-view>
    </transition>
    <!-- <div class="page-tabbar van-hairline--top" v-if="$route.meta.showTabbar">
      <app-tabbar></app-tabbar>
    </div> -->
  </div>
</template>

<script>
  // import appTabbar from '@/components/app-tabbar'

	export default {
		name: 'App',
		components: {
      // appTabbar
		},
		data() {
			return {
				transitionName: 'slide-right'
			}
		},
		watch: {
			'$route'(to, from) {
				let isBack = this.$store.state.routeIsBack; // 监听路由变化时的状态为前进还是后退
				if (isBack) {
					this.transitionName = 'pop-out'
				} else {
					this.transitionName = 'pop-in'
				}
				this.$store.commit('UPDATE_ROUTER_IS_BACK')
			}
		},
		created() {
			// this.$store.commit('UPDATE_USER_FROM_LOCAL');
		}
	}
</script>

<style lang="scss">
  #app {
    position: relative;
    height: 100%;
    &.showTabbar{
      padding-bottom: 100px;
    }
    .app-sub-page{
      height: 100%;
    }
  }

  //style
  //style
  .slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    transition: all 0.2s;
    -webkit-transform: translate(100px, 0);
    transform: translate(100px, 0);
  }

  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    transition: all 0.2s;
    -webkit-transform: translate(-100px, 0);
    transform: translate(-100px, 0);
  }

  .pop-out-enter-active,
  .pop-out-leave-active,
  .pop-in-enter-active,
  .pop-in-leave-active {
    will-change: transform;
    transition: all 250ms;
    height: 100%;
    width: 100%;
    top: 0;
    position: absolute;
    backface-visibility: hidden;
  }

  .pop-out-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .pop-out-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .pop-in-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .pop-in-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
</style>
